<template>
  <div class="flex flex-col items-center py-16">
    <div class="h-10 w-24">
      <TransitionRoot
        appear
        :show="isShowing"
        as="template"
        enter="transform transition duration-[1000ms]"
        enter-from="opacity-0 rotate-[-120deg] scale-50"
        enter-to="opacity-100 rotate-0 scale-100"
        leave="transform duration-[1000ms] transition "
        leave-from="opacity-100 rotate-0 scale-100 "
        leave-to="opacity-0 scale-95 "
      >
        <div class="flex justify-center">
          
        </div>
      </TransitionRoot>

      <TransitionRoot
        appear
        :show="isShowing"
        as="template"
        enter="transform transition duration-[1000ms]"
        enter-from="opacity-0 scale-50"
        enter-to="opacity-100 scale-100"
        leave="transform duration-[1000ms] transition "
        leave-from="opacity-100 scale-100 "
        leave-to="opacity-0 "
      >
        <div class="text-lime-600 text-lg text-center">Cargando</div>
      </TransitionRoot>
    </div>
    <div class="fa-lg text-lime-600 pt-3">
      <i
        class="fa-solid fa-circle fa-beat-fade"
        style="--fa-animation-duration: 2s; --fa-animation-delay: 0s"
      ></i>
      <span class="space-icon" />
      <i
        class="fa-solid fa-circle fa-beat-fade"
        style="--fa-animation-duration: 2s; --fa-animation-delay: 0.5s"
      ></i>
      <span class="space-icon" />
      <i
        class="fa-solid fa-circle fa-beat-fade"
        style="--fa-animation-duration: 2s; --fa-animation-delay: 1s"
      ></i>
      <span class="space-icon" />
      <i
        class="fa-solid fa-circle fa-beat-fade"
        style="--fa-animation-duration: 2s; --fa-animation-delay: 1.5s"
      ></i>
    </div>
  </div>
</template>

<script>
import { TransitionRoot } from "@headlessui/vue";

export default {
  name: "LoadingMessage",
  components: {
    TransitionRoot,
  },
  data() {
    return {
      isShowing: true,
    };
  },
  methods: {
    resetIsShowing: function () {
      this.isShowing = false;

      setTimeout(() => {
        this.isShowing = true;
      }, 2000);
    },
  },
  created() {
    setInterval(() => {
      this.isShowing = !this.isShowing;
    }, 2000);
  },
};
</script>
